import Vue from 'vue'
import App from './App.vue'
import VueGtag from "vue-gtag";

import router from './router'
import store from './store'
import '@/styles/base.scss';

Vue.config.productionTip = false

Vue.use(VueGtag, {
  config: { id: "G-9FENB4YLKD" }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
